




















































































































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseDuration from "@/components/BaseDuration";
import BaseIconButton from "@/components/BaseIconButton";
import FullScreen from "@/components/FullScreen";
import GalleryTotalItems from "@/components/GalleryTotalItems";
import ImageEditor from "@/components/ImageEditor";
import ModalView from "@/components/ModalView";
import UploadCancelConfirm from "./components/UploadCancelConfirm";
import UploadedFileItem from "./components/UploadedFileItem";

export interface DurationInfo {
  index: number;
  duration: number;
}

export default defineComponent({
  name: "UploadedFilesEditModal",
  components: {
    UploadCancelConfirm,
    BaseButton,
    BaseConfirm,
    BaseDuration,
    GalleryTotalItems,
    BaseIcon,
    UploadedFileItem,
    FullScreen,
    BaseIconButton,
    ImageEditor,
    ModalView,
  },
  props: {
    files: { type: Array as PropType<File[]>, required: true },
  },
  setup(props, { emit }) {
    const editMode = ref(false);
    const currentItemIndex = ref(0);
    const filesDurations = ref<DurationInfo[]>([]);
    const showCloseConfirm = ref(false);
    const currentItemSetter = ref<(count: number) => void>();

    const handleChangeIndex = (newIndex: number) => {
      currentItemIndex.value = newIndex;
    };

    const isCurrentItemVideo = computed(() => isVideoFile(props.files[currentItemIndex.value]));
    const isCurrentItemImage = computed(() => isImageFile(props.files[currentItemIndex.value]));
    const currentItemDuration = computed(
      () => filesDurations.value.find(item => item.index === currentItemIndex.value)?.duration ?? 0
    );

    const handleFileDuration = ({ name, duration }: { name: string; duration: number }) => {
      const fileIndex = props.files.findIndex(file => file.name === name);
      if (fileIndex > -1) {
        filesDurations.value.push({
          index: fileIndex,
          duration,
        });
      }
    };

    const handleDeleteItem = () => {
      if (props.files.length > 1) {
        emit("deleteFile", currentItemIndex.value);
        if (currentItemIndex.value === props.files.length - 1) {
          currentItemSetter.value && currentItemSetter.value(currentItemIndex.value - 1);
        }
      } else {
        emit("close");
      }
    };

    const handleCancelUpload = () => {
      showCloseConfirm.value = false;
      emit("close");
    };

    const handleUploadFiles = () => {
      emit("uploadFiles", props.files);
      emit("close");
    };

    const saveEditedFile = (blob: Blob) => {
      const file = props.files[currentItemIndex.value];
      const updatedFile = new File([blob], `${file.name}_edited`, { type: "image/jpeg" });
      emit("updateFile", {
        file: updatedFile,
        index: currentItemIndex.value,
      });
      editMode.value = false;
    };

    return {
      editMode,
      isCurrentItemVideo,
      isCurrentItemImage,
      currentItemDuration,
      showCloseConfirm,
      saveEditedFile,
      handleChangeIndex,
      handleFileDuration,
      handleCancelUpload,
      handleUploadFiles,
      handleDeleteItem,
      currentItemSetter,
    };
  },
});
